import axios from 'axios';
import { bdmAppOrigin } from '../config/sfApiBase';

/** In dev, CRA proxy forwards /api/* to localhost:3001 (see package.json "proxy"). */
function getCeoApiBase() {
  if (process.env.NODE_ENV === 'development') {
    return '/api/ceo';
  }
  return `${bdmAppOrigin()}/api/ceo`;
}

/**
 * CEO dual-period Salesforce summary + WordPress new properties (Express `/api/ceo/*`).
 * period=WEEK → last 7 days vs prior 7; MONTH → last 30 days vs prior 30 (rolling UTC).
 */
export async function fetchCeoSummary(period) {
  const p = period === 'MONTH' ? 'MONTH' : 'WEEK';
  const res = await axios.get(`${getCeoApiBase()}/summary`, { params: { period: p } });
  return res.data;
}

export async function fetchCeoWpNewProperties(period) {
  const p = period === 'MONTH' ? 'MONTH' : 'WEEK';
  const res = await axios.get(`${getCeoApiBase()}/wp-new-properties`, { params: { period: p } });
  return res.data;
}

export async function fetchCeoMetricDetail({ metric, period, window, stage, group }) {
  const res = await axios.get(`${getCeoApiBase()}/detail`, {
    params: {
      metric,
      period: period === 'MONTH' ? 'MONTH' : 'WEEK',
      window: window === 'previous' ? 'previous' : 'current',
      ...(stage ? { stage } : {}),
      ...(group != null && group !== '' ? { group } : {}),
    },
  });
  return res.data;
}

export async function fetchCeoEnquiryPipeline() {
  const res = await axios.get(`${getCeoApiBase()}/enquiry-pipeline`);
  return res.data;
}
